// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mx-table-date .today {\n  border: 1px solid var(--portal-primary);\n  color: var(--portal-primary);\n}\n.mx-datepicker {\n  min-width: 200px;\n  width: 100%;\n}\n.mx-datepicker-range {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
